export default () => ({
  isOpen: false,
  menu: null,
  subMenu: null,
  openDropdowns: {},
  toggle(show) {
    if (show !== undefined) {
      // Explicit show/hide
      this.isOpen = show;
    } else {
      // Toggle current state
      this.isOpen = !this.isOpen;
    }

    if (Alpine.store("header")) {
      Alpine.store("header").menuOpen = this.isOpen;
    }

    // Dispatch events after state change
    this.$nextTick(() => {
      if (this.isOpen) {
        document.body.style.overflow = "hidden";
        // Only dispatch header-scrolled if we're actually scrolled
        if (window.scrollY > 0) {
          window.dispatchEvent(new CustomEvent("header-scrolled"));
        }
        window.dispatchEvent(new CustomEvent("bg-toggle", { detail: true }));
      } else {
        document.body.style.overflow = "";
        this.subMenu = null;
        this.menu = null;
        this.openDropdowns = {};
        window.dispatchEvent(new CustomEvent("bg-toggle", { detail: false }));
      }
    });
  },
  setMenu(index) {
    this.menu = index;
  },
  setSubMenu(index) {
    this.subMenu = index;
  },
  toggleDropdown(dropdownId) {
    this.openDropdowns[dropdownId] = !this.openDropdowns[dropdownId];
  },
  isDropdownOpen(dropdownId) {
    return this.openDropdowns[dropdownId] || false;
  },
});
